import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import type { IReduxRequestNode, ILegacyPhoneCodes } from "@litres-libs/types";
import { Request } from "../../request/Request";
import { addHydrateReducer } from "../../utils/hydrateReducer";

interface IPhonecodesState {
  countriez: string;
  actions: {
    getPhonecodes: IReduxRequestNode<IPhonecodesRequest, IPHonecodesResponse>;
  };
}

const initialState: IPhonecodesState = {
  countriez: "", // В этой строке хранится ILegacyPhoneCodes["countriez"] массив
  actions: {
    getPhonecodes: {
      isLoading: false,
    },
  },
};

interface IPhonecodesRequest {
  gu_ajax: boolean;
}
type IPHonecodesResponse = ILegacyPhoneCodes;

/**
 * Запрос поиска по текстовому ключу
 * @deprecated
 */
export const getPhoneCodes = createAsyncThunk(
  "global/phonecodes/getPhoneCodes",
  async (params?: {
    onSuccess?: (
      success: IReduxRequestNode<IPhonecodesRequest, IPHonecodesResponse>
    ) => void;
    onError?: (
      error: IReduxRequestNode<IPhonecodesRequest, IPHonecodesResponse>
    ) => void;
  }) => {
    const response = new Request.Axios<IPhonecodesRequest, IPHonecodesResponse>(
      {
        url: "/pages/countriez_phones/",
        provider: {
          id: "phonecodes",
        },
        request: {
          method: "POST",
          params: {
            gu_ajax: true,
          },
        },
        onSuccess: params?.onSuccess,
        onError: params?.onError,
      }
    );

    return await response.fetch();
  }
);

export const phonecodesSlice = createSlice({
  name: "global/phonecodes",
  initialState,
  reducers: {
    setPhoneCodes: (state: IPhonecodesState, action: PayloadAction<string>) => {
      state.countriez = action.payload;
    },
  },
  extraReducers: builder => {
    addHydrateReducer(builder, "global.phonecodes");
    /**
     * Запрос поиска по текстовому ключу
     */
    builder.addCase(getPhoneCodes.pending, (state: IPhonecodesState) => {
      state.actions.getPhonecodes.isLoading = true;
      state.actions.getPhonecodes.error = undefined;
    });
    builder.addCase(
      getPhoneCodes.fulfilled,
      (
        state: IPhonecodesState,
        action: PayloadAction<
          IReduxRequestNode<IPhonecodesRequest, IPHonecodesResponse>
        >
      ) => {
        state.actions.getPhonecodes.isLoading = false;
        // state.actions.getPhonecodes.response = action.payload;

        if (action.payload.response?.countriez) {
          state.countriez = JSON.stringify(action.payload.response.countriez);
        }

        // TODO: Ошибку точно не надо как-то визуально обработать в интерфейсе?
        if (action.payload.error) {
          console.error("Ошибка запроса phonecodesSlice", action.payload.error);
          state.actions.getPhonecodes.error = action.payload.error;
        }
      }
    );
  },
});

export const { setPhoneCodes } = phonecodesSlice.actions;

export default phonecodesSlice.reducer;
